import type {Employee} from "$lib/types/employee";

export default function hasEmploymentStatus(employee: Employee, status: string) {
    for(let i = 0; i < employee.employmentStati.length; i++) {
        if(employee.employmentStati[i].employmentStatus === status) return true
    }
    if(employee.employmentStatus === status) return true
    return false;
}
export const hasOneOfStati = (employee: Employee, stati: string[]) => stati.some(status => hasEmploymentStatus(employee, status))